import type { AuthPermissionTypes } from 'types'

export const AUTH_PERMISSION_KEYS: Record<AuthPermissionTypes, AuthPermissionTypes> = {
  officeView: 'officeView',
  workflowAbsences: 'workflowAbsences',
  workflowMonthlySheets: 'workflowMonthlySheets',
  workflowShareUserData: 'workflowShareUserData',
  workflowShareUserDataGlobal: 'workflowShareUserDataGlobal',
  workflowShiftUpdate: 'workflowShiftUpdate',
  workflowSecureConnection: 'workflowSecureConnection',
}
